import { strengths } from '../../data/siteContent';

function WhySection() {
  return (
    <section className="block why" id="why">
      <div className="wrap">
        <div className="why-quote reveal">
          <span className="eyebrow">WHY 이동은</span>
          <p className="quote serif">“가입은 누구나 시켜줍니다.<br />중요한 건 <em>그 다음</em>을 누가 책임지느냐입니다.”</p>
        </div>
        <div className="cards">
          {strengths.map(({ title, body }) => (
            <article className="card reveal" key={title}><h3>{title}</h3><p>{body}</p></article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default WhySection;
